module.exports = __webpack_public_path__ + "static/media/hand.55d81e0a.svg";